import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBooking } from '../contexts/BookingContext';
import ProgressBar from '../components/ProgressBar';
import { communityOptions } from '../data/mockData';

const CommunityPage: React.FC = () => {
  const navigate = useNavigate();
  const { addCommunity } = useBooking();
  const [selectedOptions, setSelectedOptions] = useState<any[]>([]);

  const handleOptionToggle = (option: any) => {
    const isSelected = selectedOptions.find(item => item.id === option.id);
    if (isSelected) {
      setSelectedOptions(selectedOptions.filter(item => item.id !== option.id));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  };

  const handleNext = () => {
    selectedOptions.forEach(option => {
      addCommunity(option);
    });
    navigate('/culture-experience');
  };

  const handleSkip = () => {
    navigate('/culture-experience');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50">
      <div className="container mx-auto px-4 py-8 max-w-6xl">
        <ProgressBar currentStep={5} />
        
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            加入社群活動
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            選擇您感興趣的活動，認識志同道合的朋友
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {communityOptions.map((option) => {
            const isSelected = selectedOptions.find(item => item.id === option.id);
            
            return (
              <div
                key={option.id}
                onClick={() => handleOptionToggle(option)}
                className={`bg-white rounded-2xl shadow-soft p-6 cursor-pointer transition-all duration-300 transform hover:scale-105 hover:shadow-medium ${
                  isSelected
                    ? 'ring-4 ring-blue-200 bg-blue-50'
                    : 'hover:bg-gray-50'
                }`}
              >
                <div className="text-4xl mb-4">{option.icon}</div>
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  {option.name}
                </h3>
                <p className="text-gray-600 mb-4">{option.description}</p>
                
                <div className="space-y-2 mb-4">
                  <div className="flex items-center text-sm text-gray-500">
                    <span className="mr-2">🏷️</span>
                    <span>{option.type}</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-500">
                    <span className="mr-2">🕐</span>
                    <span>{option.time}</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-500">
                    <span className="mr-2">🌍</span>
                    <span>{option.language}</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-500">
                    <span className="mr-2">📍</span>
                    <span>{option.location}</span>
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    {option.free ? (
                      <span className="px-3 py-1 bg-green-100 text-green-700 text-sm rounded-full font-semibold">
                        免費
                      </span>
                    ) : (
                      <span className="px-3 py-1 bg-orange-100 text-orange-700 text-sm rounded-full font-semibold">
                        {option.price}
                      </span>
                    )}
                  </div>
                  
                  {isSelected && (
                    <div className="text-blue-600 font-semibold">
                      <span className="mr-1">✓</span>
                      已選擇
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          {selectedOptions.length > 0 && (
            <button
              onClick={handleNext}
              className="w-full sm:w-auto bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-semibold py-3 px-8 rounded-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-medium"
            >
              下一步 ({selectedOptions.length} 個活動)
            </button>
          )}
          
          <button
            onClick={handleSkip}
            className="w-full sm:w-auto bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold py-3 px-8 rounded-2xl transition-all duration-300"
          >
            略過社群活動
          </button>
        </div>

        {selectedOptions.length > 0 && (
          <div className="mt-8 bg-blue-50 rounded-2xl p-6 max-w-2xl mx-auto">
            <h3 className="text-lg font-semibold text-blue-800 mb-2">
              已選擇 {selectedOptions.length} 個活動：
            </h3>
            <div className="space-y-1">
              {selectedOptions.map((option) => (
                <p key={option.id} className="text-blue-600">
                  • {option.name} ({option.free ? '免費' : option.price})
                </p>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommunityPage; 